export default "__VITE_ASSET__BAWi_Sth__"